import type { BookingStatus } from '@/lib/types/booking'

export const STATUS_CONFIG: Record<BookingStatus, {
  label: string
  color: string
  textColor: string
  dotColor: string
}> = {
  request:  { label: 'Request',   color: 'bg-[var(--color-accent-amber-dim)]',  textColor: 'text-[var(--color-accent-amber)]', dotColor: '#e8a838' },
  approved: { label: 'Confirmed', color: 'bg-[var(--color-accent-green-dim)]',  textColor: 'text-[var(--color-accent-green)]', dotColor: '#7a9e7e' },
  arrived:  { label: 'Arrived',   color: 'bg-blue-500/20',                      textColor: 'text-[var(--color-accent-blue)]',   dotColor: '#6b9fd4' },
  in_delivery: { label: 'In Delivery', color: 'bg-violet-500/20',               textColor: 'text-[var(--color-accent-violet)]', dotColor: '#9b7fe8' },
  seated:   { label: 'Seated',    color: 'bg-violet-500/20',                    textColor: 'text-[var(--color-accent-violet)]', dotColor: '#9b7fe8' },
  left:     { label: 'Left',      color: 'bg-zinc-500/20',                      textColor: 'text-zinc-400',                     dotColor: '#8a8a8a' },
  no_show:  { label: 'No Show',   color: 'bg-[var(--color-accent-red-dim)]',    textColor: 'text-[var(--color-accent-red)]',    dotColor: '#c0614a' },
  canceled: { label: 'Canceled',  color: 'bg-red-500/10',                       textColor: 'text-red-500/70',                   dotColor: '#8a3a2a' },
  waitlist: { label: 'Waitlist',  color: 'bg-orange-500/20',                    textColor: 'text-orange-400',                   dotColor: '#d4874a' },
}

export function getStatusActions(status: BookingStatus): Array<{
  label: string
  targetStatus: BookingStatus
  variant: 'primary' | 'danger' | 'default'
}> {
  switch (status) {
    case 'request':
      return [
        { label: 'Approve', targetStatus: 'approved', variant: 'primary' },
        { label: 'Decline', targetStatus: 'canceled', variant: 'danger' },
      ]
    case 'approved':
      return [
        { label: 'Mark Arrived', targetStatus: 'arrived', variant: 'primary' },
        { label: 'Cancel', targetStatus: 'canceled', variant: 'danger' },
      ]
    case 'arrived':
    case 'seated':
      return [
        { label: 'Mark Left', targetStatus: 'left', variant: 'default' },
        { label: 'No Show', targetStatus: 'no_show', variant: 'danger' },
      ]
    case 'waitlist':
      return [
        { label: 'Approve', targetStatus: 'approved', variant: 'primary' },
        { label: 'Cancel', targetStatus: 'canceled', variant: 'danger' },
      ]
    default:
      return []
  }
}
